module.exports = __webpack_public_path__ + "static/img/like_0_1.43610b26.svg";